import React, { useState, useEffect } from 'react';
import Metatags from '../Metatags/Metatags';

export default function AdvertisementLanding() {

    return (
        <>

            <Metatags
                title="Garage Storage Here"
                description="Store your stuff in a garage"
                keywords="Advertise your garage, Garage rental ads, Promote garage storage, List your garage, Garage rental marketing, Rent out garage space, Post garage for rent, Garage ad listing, Affordable garage rental, Extra space promotion, Online garage listing, Garage storage ads, Public storage alternative, Local storage advertising, Find garage renters, Earn from garage"
            />
            <section className="page-content sec-padding">
                <div className="container">
                    <div className="page-content-details">
                        <div className="sec-title row">
                            <div className="col-md-6 text-start">
                                <h3>ADVERTISE WITH GarageXY</h3>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>

                                <h4>So, you would like to advertise with garage XY?</h4>
                                <p>Follow the steps below and we can deliver your advertisement to our customer base with Zip Code targeting.</p>

                                <ul className='features-pro'>
                                    <li className='ul-decimal' style={{ margin: '10px' }}><h5>Are you a -</h5></li>
                                    <ul className='ul-dot'>
                                        <li>Real Estate Agent?</li>
                                        <li>Property Manager?</li>
                                        <li>Lawyer/Attorney/Paralegal?</li>
                                        <li>Contractor?</li>
                                        <li>Garage Door Installer?</li>
                                        <li>Lock Smith?</li>

                                    </ul>
                                    <li className='ul-decimal' style={{ margin: '10px' }}><h5>Other types of businesses that surprised us-</h5></li>
                                    <ul className='ul-dot'>
                                        <li>Restaurant?</li>
                                        <li>Boat Yard?</li>
                                        <li>Giant fenced Lot with card entry?</li>
                                    </ul>
                                </ul>
                                <p className='pt-3'>All of these types of businesses are advertising with GarageXY in Zip Codes that are important to them. Maybe you will surprise us?</p>
                                <p className='pt-3'>Advertising costs $3 per zip code.&nbsp; Billing is through STRIPE and you can choose to pay ANNUALLY up front or pay MONTHLY. Because advertising with us is SO inexpensive,&nbsp; if you edit your advertisement, or add or subtract zip codes,&nbsp; you must start a new advertisement and cancel the old.&nbsp; There are NO refunds for partial period advertisements&hellip;so Monthly is suggested.</p>
                            </div>
                            <div className='col-md-12 mt-5'>
                                <div className="sec-title row">
                                    <div className="col-md-6 text-start">
                                        <h3>STEPS TO ADVERTISE:</h3>
                                    </div>
                                </div>

                                <ol>
                                    <li className='ul-number'>Create your GarageXY account</li>
                                    <li className='ul-number'>Make up your advertisement as a JPG format image to fit a&nbsp;</li>
                                    <ol>
                                        <li className='ul-decimal'>width max of 1000 pixels</li>
                                        <li className='ul-decimal'>Hight max of 400 pixels</li>
                                    </ol>
                                    <li className='ul-number'>On the USER PULLDOWN MENU select MY ADS<br />
                                        <img src='img/1.png' /></li>
                                    <li className='ul-number'>Select the ADD ADVERTISEMENT button in the upper right corner.
                                        <br />
                                        <img src='img/2.png' />
                                    </li>

                                    <li className='ul-number'>Fill out the form.</li>
                                    <li className='ul-number'>Upload your advertisement.</li>
                                    <li className='ul-number'>Choose your Zip Codes.</li>
                                    <li className='ul-number'>Click the ADD ADVERTISEMENT button.</li>
                                </ol>
                                <p>Admin will review your advertisement, and if it meets our guidelines, activate it withing 3 days. Go to GarageXY.com and verify that your advertisement is being displayed and the URL works.</p>
                                <p>&nbsp;</p>
                                <p>Lets GO !!!
                                    <a href='https://garagexy.com/sign_up' className='btn btn-primary btn-lg'>CREATE ACCOUNT</a>
                                </p>

                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}